import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/render/project/src/node_modules/.pnpm/gatsby-theme-docz@2.3.1_@babel+core@7.11.1_@types+node@24.7.0_docz@2.4.0_@babel+core@7._04842b0c5656885ffb9b2f355e30df2b/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "builder-ui--ai-operative-guide"
    }}>{`Builder UI – AI Operative Guide`}</h1>
    <p><strong parentName="p">{`TL;DR for Agents`}</strong></p>
    <ul>
      <li parentName="ul">{`Workdir `}<inlineCode parentName="li">{`/builder-ui`}</inlineCode>{`; default port 52002; backend must be running.`}</li>
      <li parentName="ul">{`Run `}<inlineCode parentName="li">{`pnpm install`}</inlineCode>{` first. Bug fixes start with `}<inlineCode parentName="li">{`pnpm test:no-coverage`}</inlineCode>{`; lint with `}<inlineCode parentName="li">{`pnpm test:lint`}</inlineCode>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Styling`}</strong>{`: Use Tailwind for component styles. Edit `}<inlineCode parentName="li">{`app/src/app.css`}</inlineCode>{` only for global design system primitives (buttons, inputs, typography); run `}<inlineCode parentName="li">{`pnpm build:css`}</inlineCode>{` if needed; never touch `}<inlineCode parentName="li">{`app/src/app.dist.css`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Lingui strings belong inside components/functions only.`}</li>
      <li parentName="ul">{`Never edit generated files: `}<inlineCode parentName="li">{`app/src/icons/index.tsx`}</inlineCode>{`, `}<inlineCode parentName="li">{`app/src/app.dist.css`}</inlineCode>{`, `}<inlineCode parentName="li">{`app/src/gql/schema.json`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`No destructive git resets; never revert user changes.`}</li>
    </ul>
    <p><strong parentName="p">{`Audience`}</strong>{`: AI agents only. Assumes you can run commands, read code, and follow guardrails.`}</p>
    <h2 {...{
      "id": "specs-directory"
    }}>{`Specs Directory`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`specs/`}</inlineCode>{` directory is a symlink to `}<inlineCode parentName="p">{`../specs`}</inlineCode>{` (a separate repository). If the symlink is broken or the specs repo is not available, continue without specs access.`}</p>
    <h2 {...{
      "id": "ignored-paths"
    }}>{`Ignored Paths`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`specs/archive/`}</inlineCode>{` - Archived specifications (if available). NEVER read, reference, or use these files.`}</li>
    </ul>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <p>{`Before starting work:`}</p>
    <ul>
      <li parentName="ul">{`Backend must be running (GraphQL dependency)`}</li>
      <li parentName="ul">{`Run `}<inlineCode parentName="li">{`pnpm install`}</inlineCode></li>
      <li parentName="ul">{`Working directory: `}<inlineCode parentName="li">{`/builder-ui`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "task-type--primary-actions"
    }}>{`Task Type → Primary Actions`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Task Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Primary Tools`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Key Sections`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`First Commands`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Bug fix`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Read, Edit, Bash`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Debugging Playbook, Architecture`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`pnpm test:no-coverage`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`New feature`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Task (Explore), TodoWrite, Edit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Core Principles, Task Recipes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Explore codebase first`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Code review`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Task (code-reviewer)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Testing Guide, Core Principles`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Review changes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Refactoring`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Read, Edit, Task`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Architecture, Core Principles`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Understand structure first`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Testing`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Read, Write`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Testing Comprehensive Guide`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`pnpm test:no-coverage`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Styling`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Edit, Bash`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Frontend Conventions (Styling)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Tailwind for components; `}<inlineCode parentName="td">{`app.css`}</inlineCode>{` for globals only`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`i18n/Translation`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Edit, Bash`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Frontend Conventions (i18n)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`pnpm extract`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h2 {...{
      "id": "context--tech-stack"
    }}>{`Context & Tech Stack`}</h2>
    <h3 {...{
      "id": "tech-stack"
    }}>{`Tech Stack`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Framework`}</strong>{`: React 18.3 + React Router 7`}</li>
      <li parentName="ul"><strong parentName="li">{`Build`}</strong>{`: Vite 7`}</li>
      <li parentName="ul"><strong parentName="li">{`Styling`}</strong>{`: Tailwind CSS 3.4 (prefer Tailwind for new code)`}</li>
      <li parentName="ul"><strong parentName="li">{`State`}</strong>{`: Apollo Client (GraphQL) + Immer`}</li>
      <li parentName="ul"><strong parentName="li">{`Language`}</strong>{`: JavaScript/JSX with TypeScript support (StandardJS style)`}</li>
      <li parentName="ul"><strong parentName="li">{`Testing`}</strong>{`: Vitest + Cypress + React Testing Library`}</li>
      <li parentName="ul"><strong parentName="li">{`i18n`}</strong>{`: Lingui (en, es, fr)`}</li>
    </ul>
    <h3 {...{
      "id": "runtime--tooling"
    }}>{`Runtime & Tooling`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Node`}</strong>{`: >=22`}</li>
      <li parentName="ul"><strong parentName="li">{`Package Manager`}</strong>{`: pnpm 10.x`}</li>
      <li parentName="ul"><strong parentName="li">{`Primary Path Alias`}</strong>{`: `}<inlineCode parentName="li">{`@`}</inlineCode>{` → `}<inlineCode parentName="li">{`app/src`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Testing Alias`}</strong>{`: `}<inlineCode parentName="li">{`@testing/*`}</inlineCode>{` → `}<inlineCode parentName="li">{`app/src/@testing/*`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Filename Convention`}</strong>{`: kebab-case (enforced by ESLint)`}</li>
    </ul>
    <h3 {...{
      "id": "entry-points--key-files"
    }}>{`Entry Points & Key Files`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Entry`}</strong>{`: `}<inlineCode parentName="li">{`app/src/index.jsx`}</inlineCode>{` mounts router from `}<inlineCode parentName="li">{`app/src/routes.jsx`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Root Layout`}</strong>{`: `}<inlineCode parentName="li">{`app/src/root-layout.jsx`}</inlineCode>{` (Apollo provider, theme, alerts, feature-flag modal, SystemError boundary, keyboard shortcuts)`}</li>
      <li parentName="ul"><strong parentName="li">{`App Config`}</strong>{`: `}<inlineCode parentName="li">{`app/src/config.jsx`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Global Styles`}</strong>{`: `}<inlineCode parentName="li">{`app/src/app.css`}</inlineCode>{` (source) → `}<inlineCode parentName="li">{`app/src/app.dist.css`}</inlineCode>{` (compiled, `}<strong parentName="li">{`never edit directly`}</strong>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`Routing`}</strong>{`: `}<inlineCode parentName="li">{`app/src/routes.jsx`}</inlineCode>{` - React Router 7 route tree`}</li>
      <li parentName="ul"><strong parentName="li">{`GraphQL Setup`}</strong>{`: `}<inlineCode parentName="li">{`app/src/gql/index.jsx`}</inlineCode>{` (Apollo Client with custom type policies)`}</li>
      <li parentName="ul"><strong parentName="li">{`GraphQL Schema`}</strong>{`: `}<inlineCode parentName="li">{`app/src/gql/schema.json`}</inlineCode>{` (generated)`}</li>
      <li parentName="ul"><strong parentName="li">{`i18n Setup`}</strong>{`: `}<inlineCode parentName="li">{`app/src/i18n.jsx`}</inlineCode></li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "architecture--structure"
    }}>{`Architecture & Structure`}</h2>
    <h3 {...{
      "id": "data-layer"
    }}>{`Data Layer`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`GraphQL`}</strong>{`: Apollo Client @ `}<inlineCode parentName="li">{`/app/api/v0/graphql`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Auth`}</strong>{`: Bearer token from `}<inlineCode parentName="li">{`authToken`}</inlineCode>{` cookie`}</li>
      <li parentName="ul"><strong parentName="li">{`WebSocket`}</strong>{`: Subscriptions via WSS`}</li>
      <li parentName="ul"><strong parentName="li">{`Cache`}</strong>{`: Custom type policies in `}<inlineCode parentName="li">{`app/src/gql/index.jsx`}</inlineCode>{` (the `}<inlineCode parentName="li">{`typePolicies`}</inlineCode>{` export, ~lines 27-172)`}</li>
      <li parentName="ul"><strong parentName="li">{`REST (Secondary)`}</strong>{`: `}<inlineCode parentName="li">{`/api/v1/*`}</inlineCode>{` for Identity Service (user management)`}</li>
    </ul>
    <h3 {...{
      "id": "backend-architecture-flow"
    }}>{`Backend Architecture Flow`}</h3>
    <pre><code parentName="pre" {...{}}>{`Frontend (React)
  ↓ GraphQL Query/Mutation
Platform (Elixir/Phoenix, \`/app/api/v0/graphql\`)
  ├─→ MongoDB (tenant/customer data, basic integrations)
  ├─→ Postgres (Oban jobs, Bridge/Lasso integrations, internal data)
  ├─→ Identity Service (Node.js/Express, \`/api/v1/users/*\`) ⇄ MongoDB (user auth data)
  ├─→ Forms API (Node.js/Express) - form processing/validation
  ├─→ Workflows API (Node.js/Express) - workflow execution
  └─→ PDF API - PDF generation

Identity Service can call Platform back for user extended attributes (bi-directional)
`}</code></pre>
    <h3 {...{
      "id": "directory-structure"
    }}>{`Directory Structure`}</h3>
    <h4 {...{
      "id": "core-application-pages"
    }}>{`Core Application Pages`}</h4>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/pages-builder/`}</inlineCode></strong>{` - Builder/configuration interface (form designer, workflow, dashboard, permissions, publishing)`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/pages-runner/`}</inlineCode></strong>{` - End-user runtime (run, edit, view forms, workflow actions, document history)`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/pages/`}</inlineCode></strong>{` - System administration (home, identity management, integrations, audit, spaces, settings, usage, permissions)`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/pages-anonymous/`}</inlineCode></strong>{` - Public form submission (unauthenticated, separate Apollo client)`}</p>
    <h4 {...{
      "id": "core-engines"
    }}>{`Core Engines`}</h4>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/formbot/`}</inlineCode></strong>{` - Form rendering engine`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`index.jsx`}</inlineCode>{` - Main formbot instance, gadget registration, validation`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`gadgets/`}</inlineCode>{` - Many gadget types including Text, Dropdown, Repeater, Table, DataLookup, and more`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`engine/`}</inlineCode>{` - Core rendering and state management`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`decorators/`}</inlineCode>{` - Validation, progressive disclosure, runtime enhancements`}</li>
      <li parentName="ul"><strong parentName="li">{`Architecture`}</strong>{`: Plugin-based; each gadget has manifest, config component, runtime component, validation`}</li>
      <li parentName="ul">{`Data-driven forms from templates`}</li>
    </ul>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/flowbot/`}</inlineCode></strong>{` - Visual workflow designer and execution engine`}</p>
    <ul>
      <li parentName="ul">{`Custom-built linear workflow editor with drag-and-drop (using voronoi-dnd)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`engine/`}</inlineCode>{` - Visual editor, viewer, configuration panel, validation, simulation`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`steps/`}</inlineCode>{` - 9 step types: approval, task, notification, formfill, acknowledge, conditional, integration, echo, trigger`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`components/`}</inlineCode>{` - UI components (email builder, person picker, etc.)`}</li>
      <li parentName="ul">{`Supports nested subflows (denial paths, conditional branches)`}</li>
      <li parentName="ul">{`Integrates with formbot for form data flow`}</li>
    </ul>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/voronoi-dnd/`}</inlineCode></strong>{` - Generic drag-and-drop library`}</p>
    <ul>
      <li parentName="ul">{`Uses Voronoi diagrams for intelligent drop target detection`}</li>
      <li parentName="ul">{`Framework-agnostic core in `}<inlineCode parentName="li">{`voronoi.jsx`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`draggable.jsx`}</inlineCode>{`, `}<inlineCode parentName="li">{`drop-zone.jsx`}</inlineCode>{`, `}<inlineCode parentName="li">{`gatherer.jsx`}</inlineCode>{`, `}<inlineCode parentName="li">{`item.jsx`}</inlineCode>{`, `}<inlineCode parentName="li">{`context.jsx`}</inlineCode></li>
    </ul>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/voronoi-dnd-formbot/`}</inlineCode></strong>{` - Form-specific DND implementation`}</p>
    <ul>
      <li parentName="ul">{`Adapter between voronoi-dnd and formbot`}</li>
      <li parentName="ul">{`Handles nested containers (sections, repeaters, tables)`}</li>
      <li parentName="ul">{`Grid snapping, empty states, gadget palette dragging`}</li>
    </ul>
    <h4 {...{
      "id": "shared-infrastructure"
    }}>{`Shared Infrastructure`}</h4>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/components/`}</inlineCode></strong>{` - Shared UI components: layouts, modals (`}<inlineCode parentName="p">{`modal-centered.jsx`}</inlineCode>{`, `}<inlineCode parentName="p">{`modal-page.jsx`}</inlineCode>{`), data tables, identity pickers, feature flags, error boundaries, spinners`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/ui/`}</inlineCode></strong>{` - Complex system primitives and utilities: alerts, popovers, tabs, tooltips, lookup, theme utilities, a11y helpers, and shadcn components (dropdown-menu, sheet, sidebar, skeleton)`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/icons/`}</inlineCode></strong>{` - Auto-generated SVG icons (never edit `}<inlineCode parentName="p">{`index.tsx`}</inlineCode>{` manually, use import scripts)`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/illustrations/`}</inlineCode></strong>{` - Decorative SVGs for empty states and success screens`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/gql/`}</inlineCode></strong>{` - GraphQL config: Apollo Client setup (`}<inlineCode parentName="p">{`index.jsx`}</inlineCode>{`), schema (`}<inlineCode parentName="p">{`schema.json`}</inlineCode>{`), type policies`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`app/src/@testing/`}</inlineCode></strong>{` - Test utilities: Mockley, test helpers, fixtures. Setup in `}<inlineCode parentName="p">{`.test/setup.js`}</inlineCode></p>
    <h3 {...{
      "id": "key-architectural-patterns"
    }}>{`Key Architectural Patterns`}</h3>
    <h4 {...{
      "id": "separation-of-concerns"
    }}>{`Separation of Concerns`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Configuration/Admin`}</strong>{`: `}<inlineCode parentName="li">{`pages-builder/`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`End-user Runtime`}</strong>{`: `}<inlineCode parentName="li">{`pages-runner/`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`System Administration`}</strong>{`: `}<inlineCode parentName="li">{`pages/`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Shared UI`}</strong>{`: `}<inlineCode parentName="li">{`components/`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Design Primitives`}</strong>{`: `}<inlineCode parentName="li">{`ui/`}</inlineCode></li>
    </ul>
    <h4 {...{
      "id": "form-system-architecture"
    }}>{`Form System Architecture`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Core Engine`}</strong>{`: `}<inlineCode parentName="li">{`formbot/`}</inlineCode>{` with many gadget types`}</li>
      <li parentName="ul"><strong parentName="li">{`Generic DND`}</strong>{`: `}<inlineCode parentName="li">{`voronoi-dnd/`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Form-specific DND`}</strong>{`: `}<inlineCode parentName="li">{`voronoi-dnd-formbot/`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Data-driven`}</strong>{`: Forms rendered from templates`}</li>
    </ul>
    <h4 {...{
      "id": "workflow-system"
    }}>{`Workflow System`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Visual Designer & Execution`}</strong>{`: `}<inlineCode parentName="li">{`flowbot/`}</inlineCode>{` - custom-built linear workflow editor with drag-and-drop`}</li>
      <li parentName="ul"><strong parentName="li">{`Integration`}</strong>{`: Workflows integrate with formbot for form data flow`}</li>
    </ul>
    <h4 {...{
      "id": "state-management"
    }}>{`State Management`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Server State`}</strong>{`: Apollo Client (GraphQL)`}</li>
      <li parentName="ul"><strong parentName="li">{`Local UI State`}</strong>{`: React state`}</li>
      <li parentName="ul"><strong parentName="li">{`Immutable Updates`}</strong>{`: Immer`}</li>
      <li parentName="ul"><strong parentName="li">{`Cross-cutting Concerns`}</strong>{`: Context API`}</li>
    </ul>
    <h4 {...{
      "id": "data-sharing-patterns"
    }}>{`Data Sharing Patterns`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Preferred`}</strong>{`: Use dedicated Context API for specific data or Apollo cache`}</li>
      <li parentName="ul"><strong parentName="li">{`Legacy (avoid in new code)`}</strong>{`: `}<inlineCode parentName="li">{`useOutletContext`}</inlineCode>{` exists from React Router 7 migration; prefer Context/Apollo for new features`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "configuration--infrastructure"
    }}>{`Configuration & Infrastructure`}</h2>
    <h3 {...{
      "id": "environment-variables"
    }}>{`Environment Variables`}</h3>
    <p>{`Critical environment variables used throughout the application:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`VITE_SENTRY_RELEASE`}</strong>{`: Sentry release version (enables Sentry if set)`}</li>
      <li parentName="ul"><strong parentName="li">{`VITE_SENTRY_DSN`}</strong>{`: Sentry DSN for error reporting`}</li>
      <li parentName="ul"><strong parentName="li">{`VITE_SENTRY_ENV`}</strong>{`: Environment name (development/staging/production)`}</li>
      <li parentName="ul"><strong parentName="li">{`PUBLIC_URL`}</strong>{`: Base path for static assets (used throughout for icon paths)`}</li>
      <li parentName="ul"><strong parentName="li">{`PORT`}</strong>{`: Dev server port (default: 52002 from build.service.json5)`}</li>
      <li parentName="ul"><strong parentName="li">{`NO_HMR`}</strong>{`: Disable hot module replacement if set`}</li>
    </ul>
    <p><strong parentName="p">{`Configuration lives in `}<inlineCode parentName="strong">{`app/src/config.jsx`}</inlineCode>{`:`}</strong></p>
    <ul>
      <li parentName="ul">{`Sentry setup with custom beforeBreadcrumb/beforeSend`}</li>
      <li parentName="ul">{`Apollo Client config (name, version, URI)`}</li>
      <li parentName="ul">{`AnnounceKit widget config`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`window.loggedInUser`}</inlineCode>{` used throughout for user context`}</li>
    </ul>
    <h3 {...{
      "id": "apollo-cache-type-policies"
    }}>{`Apollo Cache Type Policies`}</h3>
    <p><strong parentName="p">{`Location`}</strong>{`: `}<inlineCode parentName="p">{`app/src/gql/index.jsx`}</inlineCode>{` (the `}<inlineCode parentName="p">{`typePolicies`}</inlineCode>{` export, ~lines 27-172)`}</p>
    <p><strong parentName="p">{`Why they exist`}</strong>{`: Workarounds for caching issues caused by API design/query patterns. Ideally would be addressed at API level.`}</p>
    <p><strong parentName="p">{`Existing policies`}</strong>{` (understand these when reading code, avoid adding new ones if possible):`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`groupsConnection, membersConnection`}</strong>{` - Merge paginated edges, dedupe by `}<inlineCode parentName="li">{`__ref`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Dataset`}</strong>{` - Custom key includes `}<inlineCode parentName="li">{`formVersion.id`}</inlineCode>{` to cache different versions separately`}</li>
      <li parentName="ul"><strong parentName="li">{`Field`}</strong>{` - Disable normalization (`}<inlineCode parentName="li">{`keyFields: false`}</inlineCode>{`) - too dynamic to cache`}</li>
      <li parentName="ul"><strong parentName="li">{`Document.viewer`}</strong>{` - Always replace (don't merge) to avoid stale data`}</li>
      <li parentName="ul"><strong parentName="li">{`ActionsPaginatedConnection`}</strong>{` - Merge edges with custom sort`}</li>
    </ul>
    <p><strong parentName="p">{`If experiencing cache issues`}</strong>{`: First investigate if query/API can be fixed. Only add type policy as last resort.`}</p>
    <h3 {...{
      "id": "error-handling--monitoring"
    }}>{`Error Handling & Monitoring`}</h3>
    <p><strong parentName="p">{`Error Boundary:`}</strong></p>
    <ul>
      <li parentName="ul">{`Root layout uses `}<inlineCode parentName="li">{`SystemError`}</inlineCode>{` component (`}<inlineCode parentName="li">{`app/src/components/system-error.jsx`}</inlineCode>{`)`}</li>
      <li parentName="ul">{`Catches React errors, reports to Sentry with context`}</li>
      <li parentName="ul">{`401 errors redirect to `}<inlineCode parentName="li">{`/auth`}</inlineCode>{`, permission errors redirect to `}<inlineCode parentName="li">{`Forbidden`}</inlineCode>{` component`}</li>
    </ul>
    <p><strong parentName="p">{`Sentry Integration:`}</strong></p>
    <ul>
      <li parentName="ul">{`Configured in `}<inlineCode parentName="li">{`app/src/config.jsx`}</inlineCode>{` with custom breadcrumb/error context`}</li>
      <li parentName="ul">{`Only enabled when `}<inlineCode parentName="li">{`VITE_SENTRY_RELEASE`}</inlineCode>{` is set`}</li>
    </ul>
    <p><strong parentName="p">{`GraphQL Errors:`}</strong></p>
    <ul>
      <li parentName="ul">{`Network 401 → redirects to `}<inlineCode parentName="li">{`/auth?return_to=<current>`}</inlineCode></li>
      <li parentName="ul">{`Permission errors → shows `}<inlineCode parentName="li">{`Forbidden`}</inlineCode>{` component`}</li>
      <li parentName="ul">{`Use `}<inlineCode parentName="li">{`ExplicitError`}</inlineCode>{` or `}<inlineCode parentName="li">{`GraphQLError`}</inlineCode>{` components for manual error display`}</li>
    </ul>
    <h3 {...{
      "id": "content-security-policy-csp"
    }}>{`Content Security Policy (CSP)`}</h3>
    <p><strong parentName="p">{`Adding new external domains:`}</strong></p>
    <ol>
      <li parentName="ol">{`Edit `}<inlineCode parentName="li">{`scripts/generate-csp/index.js`}</inlineCode></li>
      <li parentName="ol">{`Add domain to appropriate policy object (`}<inlineCode parentName="li">{`script-src`}</inlineCode>{`, `}<inlineCode parentName="li">{`connect-src`}</inlineCode>{`, `}<inlineCode parentName="li">{`img-src`}</inlineCode>{`)`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`node scripts/generate-csp`}</inlineCode>{` to verify`}</li>
    </ol>
    <p>{`CSP includes third-party integrations (AnnounceKit, ChurnZero, Sentry), allows `}<inlineCode parentName="p">{`'unsafe-inline'`}</inlineCode>{`, WebSocket across Kuali domains, S3 image buckets.`}</p>
    <h3 {...{
      "id": "html-sanitization"
    }}>{`HTML Sanitization`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`app/src/components/sanitize.jsx`}</inlineCode>{` for sanitizing user-generated HTML in rich text gadgets and email content.`}</p>
    <h3 {...{
      "id": "git-hooks-husky"
    }}>{`Git Hooks (Husky)`}</h3>
    <p>{`Pre-commit runs Prettier + ESLint on staged files (configure via `}<inlineCode parentName="p">{`git config hooks.validatebuilderui on|off|custom`}</inlineCode>{`). Bypass with `}<inlineCode parentName="p">{`--no-verify`}</inlineCode>{`.`}</p>
    <h3 {...{
      "id": "eslint-configuration"
    }}>{`ESLint Configuration`}</h3>
    <p>{`Config: `}<inlineCode parentName="p">{`eslint.config.mjs`}</inlineCode>{` (ESLint 9 flat config)`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Enforces`}</strong>{`: kebab-case filenames, GraphQL schema validation, StandardJS style`}</li>
      <li parentName="ul"><strong parentName="li">{`Max warnings`}</strong>{`: 112 allowed`}</li>
      <li parentName="ul">{`Many a11y rules disabled - still follow best practices (aria-labels, role attributes, aria-describedby, aria-invalid)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "core-development-principles"
    }}>{`Core Development Principles`}</h2>
    <p>{`Prioritize thoroughness over speed. Correctness and consistency matter more than quick completion. Always read existing code, understand patterns, write tests, and verify changes work properly. Taking time to do it right prevents technical debt.`}</p>
    <h3 {...{
      "id": "1-match-existing-patterns"
    }}>{`1. Match Existing Patterns`}</h3>
    <p><strong parentName="p">{`Always read code before modifying it.`}</strong>{` Never propose changes to files you haven't read. Before adding or modifying code:`}</p>
    <ul>
      <li parentName="ul">{`Read the target file and related files`}</li>
      <li parentName="ul">{`Identify existing patterns (naming, structure, error handling, imports)`}</li>
      <li parentName="ul">{`Match the established conventions exactly`}</li>
      <li parentName="ul">{`Look for similar functionality nearby and follow that approach`}</li>
      <li parentName="ul">{`Use the same libraries/utilities already in use (don't introduce new ones for existing problems)`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong>{`: If modifying a GraphQL mutation file and all existing mutations use `}<inlineCode parentName="p">{`mapValues(keyBy(...))`}</inlineCode>{` for error handling, use that same pattern - don't introduce a new approach.`}</p>
    <h3 {...{
      "id": "2-know-your-javascriptes6-limitations"
    }}>{`2. Know Your JavaScript/ES6 Limitations`}</h3>
    <p>{`Check MDN documentation - arrays have `}<inlineCode parentName="p">{`.includes()`}</inlineCode>{`, not `}<inlineCode parentName="p">{`.contains()`}</inlineCode></p>
    <h3 {...{
      "id": "3-data-structure-consistency-over-cleverness"
    }}>{`3. Data Structure Consistency Over Cleverness`}</h3>
    <p>{`Use clear, semantic field names (`}<inlineCode parentName="p">{`type`}</inlineCode>{`, `}<inlineCode parentName="p">{`parts`}</inlineCode>{`). Don't overload fields for multiple purposes.`}</p>
    <h3 {...{
      "id": "4-recursive-pattern-recognition"
    }}>{`4. Recursive Pattern Recognition`}</h3>
    <p>{`When handling nested structures, check for nested patterns first before handling leaf nodes.`}</p>
    <h3 {...{
      "id": "5-test-data-must-mirror-production"
    }}>{`5. Test Data Must Mirror Production`}</h3>
    <p>{`Test fixtures must use exact same structure as production code with all required fields.`}</p>
    <h3 {...{
      "id": "6-filter-early-process-clean-data"
    }}>{`6. Filter Early, Process Clean Data`}</h3>
    <p>{`Remove incomplete/invalid data before processing - validate at boundaries.`}</p>
    <h3 {...{
      "id": "7-handle-both-legacy-and-new-formats"
    }}>{`7. Handle Both Legacy and New Formats`}</h3>
    <p>{`Support both old and new patterns during transitions. Transform at edges, not throughout.`}</p>
    <h3 {...{
      "id": "8-defensive-programming"
    }}>{`8. Defensive Programming`}</h3>
    <p>{`Always validate data existence. Check arrays/objects exist before operations. Return early with sensible defaults.`}</p>
    <h3 {...{
      "id": "9-favor-clarity-over-cleverness"
    }}>{`9. Favor Clarity Over Cleverness`}</h3>
    <p>{`Avoid premature abstraction. Compose small components. Separate business logic from presentation.`}</p>
    <h3 {...{
      "id": "10-avoid-over-engineering"
    }}>{`10. Avoid Over-Engineering`}</h3>
    <p>{`Only make requested changes. Keep solutions simple. Don't add features beyond requirements. Three similar lines > premature abstraction.`}</p>
    <h3 {...{
      "id": "11-test-behavior-not-implementation"
    }}>{`11. Test Behavior, Not Implementation`}</h3>
    <p>{`Test what code does, not how. Focus on user-visible behavior. Cover happy path + edge cases. Avoid testing internals.`}</p>
    <h3 {...{
      "id": "12-avoid-useeffect---use-only-when-necessary"
    }}>{`12. Avoid useEffect - Use Only When Necessary`}</h3>
    <p><strong parentName="p">{`Only use `}<inlineCode parentName="strong">{`useEffect`}</inlineCode>{` for external system synchronization`}</strong>{` (WebSockets, DOM manipulation, third-party libraries, analytics).`}</p>
    <p><strong parentName="p">{`Never use `}<inlineCode parentName="strong">{`useEffect`}</inlineCode>{` for:`}</strong></p>
    <ul>
      <li parentName="ul">{`Deriving state → compute during render`}</li>
      <li parentName="ul">{`Event handling → use onClick/onChange handlers`}</li>
      <li parentName="ul">{`Data fetching → use Apollo queries or React Router loaders`}</li>
      <li parentName="ul">{`Initialization → use useMemo or useState initializer`}</li>
    </ul>
    <p>{`Always include cleanup functions to prevent memory leaks.`}</p>
    <h3 {...{
      "id": "13-minimal-diffs"
    }}>{`13. Minimal Diffs`}</h3>
    <p>{`Only change what's necessary for your task. Don't rename variables, reformat code, fix typos, add/remove whitespace, or refactor unrelated logic. Keep diffs focused on the actual functional change.`}</p>
    <p><strong parentName="p">{`However, when your change makes something obsolete:`}</strong></p>
    <ul>
      <li parentName="ul">{`DO remove variables that become unused`}</li>
      <li parentName="ul">{`DO simplify conditions that become trivial`}</li>
      <li parentName="ul">{`DO remove unnecessary operations (like `}<inlineCode parentName="li">{`.filter(Boolean)`}</inlineCode>{` on non-conditional arrays)`}</li>
    </ul>
    <p>{`These are not "extra" changes—they're completing the work. A variable that's assigned-but-never-used after your change should be removed as part of the same change. Every line touched increases review burden and merge conflict risk, but leaving dead code is worse.`}</p>
    <h3 {...{
      "id": "14-eliminate-intermediate-variables"
    }}>{`14. Eliminate Intermediate Variables`}</h3>
    <p>{`When a variable is simply assigned once and never reassigned, use the original value directly instead of creating an intermediate variable.`}</p>
    <p><strong parentName="p">{`Bad:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const gadgets = anonymousDisabledGadgets
if (gadgets.has(gadget.key)) return true
`}</code></pre>
    <p><strong parentName="p">{`Good:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`if (anonymousDisabledGadgets.has(gadget.key)) return true
`}</code></pre>
    <p><strong parentName="p">{`Exception:`}</strong>{` Keep intermediate variables when they:`}</p>
    <ul>
      <li parentName="ul">{`Improve readability for complex expressions`}</li>
      <li parentName="ul">{`Are computed values (not simple reassignments)`}</li>
      <li parentName="ul">{`Are used multiple times in a way that would duplicate complex logic`}</li>
    </ul>
    <h3 {...{
      "id": "15-prefer-typescript-for-new-files"
    }}>{`15. Prefer TypeScript for New Files`}</h3>
    <p>{`Completely new files should be TypeScript (`}<inlineCode parentName="p">{`.ts`}</inlineCode>{` for utilities, `}<inlineCode parentName="p">{`.tsx`}</inlineCode>{` for components) when it makes sense. It makes sense when the file's contracts benefit from types (data shapes, module APIs) and its imports are typed enough to satisfy `}<inlineCode parentName="p">{`strict`}</inlineCode>{` mode honestly. It does not make sense when the file would need pervasive `}<inlineCode parentName="p">{`any`}</inlineCode>{` to compile — e.g. components consuming untyped repo-wide prop shapes — in which case `}<inlineCode parentName="p">{`.js`}</inlineCode>{`/`}<inlineCode parentName="p">{`.jsx`}</inlineCode>{` is the honest choice until those shapes are typed. Never convert existing files as a side effect of another change (see Minimal Diffs).`}</p>
    <h3 {...{
      "id": "16-no-ticket-numbers-in-code-comments"
    }}>{`16. No Ticket Numbers in Code Comments`}</h3>
    <p>{`Never reference ticket/issue numbers (PLT-1234, JIRA keys, PR numbers) in code comments. Provenance lives in git blame — the commit message and PR carry the ticket link. Ticket numbers in comments add noise, go stale, and make code harder to read.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// Wrong
// PLT-5040: compare mode previously crashed when the diff element
// was passed through getMaskedValue.

// Correct — explain the why; let git blame carry the ticket
// Compare mode previously crashed when the diff element was passed
// through getMaskedValue.
`}</code></pre>
    <p>{`Ticket numbers still belong in commit messages, PR titles/descriptions, and spec documents — just not in the code itself.`}</p>
    <hr></hr>
    <h2 {...{
      "id": "self-review-checklist"
    }}>{`Self-Review Checklist`}</h2>
    <p>{`Before considering work complete, review your changes for:`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Unnecessary complexity`}</strong>{`: Can any intermediate variables be eliminated?`}</li>
      <li parentName="ol"><strong parentName="li">{`Dead code`}</strong>{`: Are there variables declared but never used after your changes?`}</li>
      <li parentName="ol"><strong parentName="li">{`Redundant operations`}</strong>{`: Did you remove `}<inlineCode parentName="li">{`.filter(Boolean)`}</inlineCode>{` when arrays no longer have conditional elements?`}</li>
      <li parentName="ol"><strong parentName="li">{`Simplified conditions`}</strong>{`: Did you fully simplify boolean logic after removing flags?`}</li>
      <li parentName="ol"><strong parentName="li">{`Consistent patterns`}</strong>{`: Does your code match the simplicity level of surrounding code?`}</li>
    </ol>
    <p>{`This self-review catches issues that PR reviewers would otherwise need to point out.`}</p>
    <hr></hr>
    <h2 {...{
      "id": "process--resource-safeguards"
    }}>{`Process & Resource Safeguards`}</h2>
    <h3 {...{
      "id": "test-execution-limits"
    }}>{`Test Execution Limits`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Never run tests in an infinite retry loop.`}</strong>{` If tests fail twice in a row with the same error, stop and report the issue to the user rather than retrying.`}</li>
      <li parentName="ul"><strong parentName="li">{`Limit concurrent test processes.`}</strong>{` Never spawn more than one test runner process at a time. Wait for the previous test run to complete before starting another.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kill orphaned processes.`}</strong>{` If a test run times out or fails, ensure the process is terminated before starting a new one.`}</li>
    </ul>
    <h3 {...{
      "id": "failure-handling"
    }}>{`Failure Handling`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`After 2 consecutive identical failures`}</strong>{`, stop and ask the user for guidance rather than continuing to retry.`}</li>
      <li parentName="ul"><strong parentName="li">{`If a command appears to hang`}</strong>{` (no output for 2+ minutes), terminate it and report the issue rather than spawning additional processes.`}</li>
      <li parentName="ul"><strong parentName="li">{`Never run watch mode tests`}</strong>{` (`}<inlineCode parentName="li">{`pnpm test:watch`}</inlineCode>{`) in automated fix loops - use `}<inlineCode parentName="li">{`pnpm test:no-coverage`}</inlineCode>{` for single runs instead.`}</li>
    </ul>
    <h3 {...{
      "id": "memory-intensive-operations"
    }}>{`Memory-Intensive Operations`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Avoid parallel test runs.`}</strong>{` Run `}<inlineCode parentName="li">{`pnpm test:no-coverage`}</inlineCode>{` sequentially, not in parallel with other resource-intensive commands.`}</li>
      <li parentName="ul"><strong parentName="li">{`Check for running processes`}</strong>{` before spawning new test runs. If a test process is already running, wait for it to complete.`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "frontend-conventions"
    }}>{`Frontend Conventions`}</h2>
    <h3 {...{
      "id": "lowkeyui-styleguide-start-here-for-any-ui-work"
    }}>{`LowkeyUI Styleguide (start here for any UI work)`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Live styleguide (dev only)`}</strong>{`: `}<inlineCode parentName="li">{`https://local.kualibuild.com:4001/styleguide`}</inlineCode>{`
(port = 4000 + af container index; in-container: `}<inlineCode parentName="li">{`https://local.kualibuild.com/styleguide`}</inlineCode>{`).
Renders the real lowkey components with per-section source-of-truth pointers.`}</li>
      <li parentName="ul"><strong parentName="li">{`Source of truth for lowkey styles`}</strong>{`: `}<inlineCode parentName="li">{`app/src/app.css`}</inlineCode>{` (the `}<inlineCode parentName="li">{`.lowkey`}</inlineCode>{` /
`}<inlineCode parentName="li">{`.lowkey-forms`}</inlineCode>{` blocks), `}<inlineCode parentName="li">{`app/src/ui/`}</inlineCode>{`, `}<inlineCode parentName="li">{`app/src/ui/shadcn/`}</inlineCode>{`,
`}<inlineCode parentName="li">{`tailwind.config.js`}</inlineCode>{`. Never copy styles from reference docs or snapshots —
import the components or use the `}<inlineCode parentName="li">{`kp-*`}</inlineCode>{` classes.`}</li>
      <li parentName="ul"><strong parentName="li">{`Icons`}</strong>{`: lowkey UI always uses the new outline set —
`}<inlineCode parentName="li">{`import * as NewIcons from 'app/src/icons/index-new'`}</inlineCode>{` (`}<inlineCode parentName="li">{`raw-lowkey-ui/`}</inlineCode>{`).
Never the legacy `}<inlineCode parentName="li">{`app/src/icons`}</inlineCode>{` set in new lowkey work. App icons and
dataset icons are separate systems — do not replace those.`}</li>
      <li parentName="ul"><strong parentName="li">{`Gotchas`}</strong>{`: the Tailwind config REPLACES the `}<inlineCode parentName="li">{`textColor`}</inlineCode>{`/`}<inlineCode parentName="li">{`borderColor`}</inlineCode>{`
palettes with tokens (`}<inlineCode parentName="li">{`text-default`}</inlineCode>{`, `}<inlineCode parentName="li">{`border-default`}</inlineCode>{`…) — `}<inlineCode parentName="li">{`text-stone-*`}</inlineCode>{`
doesn't exist. Plain utilities lose to lowkey component rules — use `}<inlineCode parentName="li">{`!`}</inlineCode>{`
important (e.g. `}<inlineCode parentName="li">{`!border-red-500`}</inlineCode>{`) for state overrides on `}<inlineCode parentName="li">{`kp-*`}</inlineCode>{` controls.
`}<inlineCode parentName="li">{`:has()`}</inlineCode>{` selectors get strict parsing — no trailing commas in `}<inlineCode parentName="li">{`:is()`}</inlineCode>{` lists.`}</li>
      <li parentName="ul"><strong parentName="li">{`HTML snapshot`}</strong>{` for visual verification outside the dev env:
`}<inlineCode parentName="li">{`node scripts/export-styleguide/index.mjs`}</inlineCode>{` (writes the workspace
`}<inlineCode parentName="li">{`__drops/lowkey-components.html`}</inlineCode>{`).`}</li>
    </ul>
    <h3 {...{
      "id": "authentication--data-flow"
    }}>{`Authentication & Data Flow`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Backend topology`}</strong>{`: See "Backend Architecture Flow" diagram above`}</li>
      <li parentName="ul"><strong parentName="li">{`Auth flow`}</strong>{`: 401 redirects to `}<inlineCode parentName="li">{`/auth`}</inlineCode>{`; uses `}<inlineCode parentName="li">{`window.loggedInUser`}</inlineCode>{` or fetches from `}<inlineCode parentName="li">{`/api/v1/users/current`}</inlineCode>{`; token in `}<inlineCode parentName="li">{`authToken`}</inlineCode>{` cookie`}</li>
      <li parentName="ul"><strong parentName="li">{`SSO users`}</strong>{`: Have `}<inlineCode parentName="li">{`ssoId`}</inlineCode>{` field (SAML/CAS/LDAP). Cannot set/change passwords (HTTP 400)`}</li>
      <li parentName="ul"><strong parentName="li">{`Password users`}</strong>{`: Have `}<inlineCode parentName="li">{`passwordDigest`}</inlineCode>{` (bcrypt, 10 rounds). Backend never returns password; UI enforces complexity rules`}</li>
      <li parentName="ul">{`Institutions can mix both auth types; always check `}<inlineCode parentName="li">{`user.ssoId`}</inlineCode>{` per-user`}</li>
    </ul>
    <h3 {...{
      "id": "modal-usage"
    }}>{`Modal Usage`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`CenterModal`}</inlineCode>{` (`}<inlineCode parentName="p">{`app/src/components/modal-centered.jsx`}</inlineCode>{`):`}</p>
    <ul>
      <li parentName="ul">{`Automatically provides `}<inlineCode parentName="li">{`role="dialog"`}</inlineCode>{`, `}<inlineCode parentName="li">{`aria-modal="true"`}</inlineCode>{`, focus trap, ESC/backdrop handling, animations`}</li>
      <li parentName="ul"><strong parentName="li">{`Required`}</strong>{`: Modal heading must use `}<inlineCode parentName="li">{`id="modal-title"`}</inlineCode>{` (hardcoded expectation)`}</li>
      <li parentName="ul"><strong parentName="li">{`Focus management`}</strong>{`: You're responsible for returning focus to the trigger element`}
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-javascript"
          }}>{`const triggerRef = useRef()
// After modal dismiss:
setTimeout(() => triggerRef.current?.focus(), 100)
`}</code></pre>
      </li>
      <li parentName="ul"><strong parentName="li">{`Animations`}</strong>{`: Uses `}<inlineCode parentName="li">{`Preserve`}</inlineCode>{` + `}<inlineCode parentName="li">{`Transition`}</inlineCode>{` components (300ms default)`}</li>
    </ul>
    <p>{`For full-page/side-drawer modals, use `}<inlineCode parentName="p">{`modal-page.jsx`}</inlineCode>{` with nesting support.`}</p>
    <h3 {...{
      "id": "alerts--toasts"
    }}>{`Alerts & Toasts`}</h3>
    <p>{`Use `}<inlineCode parentName="p">{`useAlerts()`}</inlineCode>{` from `}<inlineCode parentName="p">{`app/src/ui/alerts.jsx`}</inlineCode>{`:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`type1`}</strong>{`: Dialog`}</li>
      <li parentName="ul"><strong parentName="li">{`type2`}</strong>{`: Banner`}</li>
      <li parentName="ul"><strong parentName="li">{`type3`}</strong>{`: Toast (auto-dismiss after 4 seconds)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const alerts = useAlerts()
alerts.type3(t\`Password updated successfully\`, 'success')
`}</code></pre>
    <h3 {...{
      "id": "state-management-1"
    }}>{`State Management`}</h3>
    <p><strong parentName="p">{`Immutable Updates`}</strong>{`: Always spread entire objects in onChange handlers (never partial updates). Use Immer for complex nested updates.`}</p>
    <h3 {...{
      "id": "styling-conventions"
    }}>{`Styling Conventions`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Local component styles`}</strong>{`: Use Tailwind CSS utilities (preferred for all component-specific styling)`}</li>
      <li parentName="ul"><strong parentName="li">{`Global styles`}</strong>{`: Edit `}<inlineCode parentName="li">{`app/src/app.css`}</inlineCode>{` only for design system primitives (buttons, inputs, typography, etc.); never edit `}<inlineCode parentName="li">{`app/src/app.dist.css`}</inlineCode>{` (generated)`}</li>
      <li parentName="ul"><strong parentName="li">{`Error text`}</strong>{`: `}<inlineCode parentName="li">{`text-red-500`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Disabled inputs`}</strong>{`: `}<inlineCode parentName="li">{`cursor-not-allowed bg-light-gray-100`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Theme colors`}</strong>{`: CSS vars like `}<inlineCode parentName="li">{`--bg`}</inlineCode>{`, `}<inlineCode parentName="li">{`--text-default`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Tailwind config`}</strong>{`: `}<inlineCode parentName="li">{`tailwind.config.js`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Animations`}</strong>{`: `}<inlineCode parentName="li">{`tw-animate-css`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "accessibility-a11y"
    }}>{`Accessibility (a11y)`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Interactive elements`}</strong>{`: Every control needs ARIA labeling`}</li>
      <li parentName="ul"><strong parentName="li">{`aria-describedby`}</strong>{`: Reference all descriptive content (help text, format hints, error messages) using space-separated IDs`}</li>
      <li parentName="ul"><strong parentName="li">{`Validation messages`}</strong>{`: Require `}<inlineCode parentName="li">{`role="alert"`}</inlineCode>{` and must be referenced via `}<inlineCode parentName="li">{`aria-describedby`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Invalid inputs`}</strong>{`: Set `}<inlineCode parentName="li">{`aria-invalid="true"`}</inlineCode>{` when errors exist`}</li>
      <li parentName="ul"><strong parentName="li">{`Modal headings`}</strong>{`: Must use `}<inlineCode parentName="li">{`id="modal-title"`}</inlineCode>{` for proper announcement`}</li>
    </ul>
    <h3 {...{
      "id": "internationalization-i18n"
    }}>{`Internationalization (i18n)`}</h3>
    <p>{`Use Lingui macros (`}<inlineCode parentName="p">{`@lingui/react/macro`}</inlineCode>{`):`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { Trans } from '@lingui/react/macro'
import { useLingui } from '@lingui/react'

// In component
const { t, i18n } = useLingui()
<Trans>Welcome message</Trans>
const message = t\`Dynamic message\`

// Date/number formatting
i18n.date(new Date())
i18n.number(1234.56)
`}</code></pre>
    <p><strong parentName="p">{`Rules`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Never call `}<inlineCode parentName="strong">{`t()`}</inlineCode>{` at module root`}</strong>{` - only inside components/functions`}</li>
      <li parentName="ul">{`Supported locales: en, es, fr`}</li>
      <li parentName="ul">{`Messages live in `}<inlineCode parentName="li">{`app/src/locales/<locale>/messages.{po/js}`}</inlineCode></li>
      <li parentName="ul">{`After adding/changing strings: `}<inlineCode parentName="li">{`pnpm extract`}</inlineCode>{` to update .po catalogs`}</li>
      <li parentName="ul">{`Commit .po changes`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`build:i18n`}</inlineCode>{` compiles catalogs (dev scripts watch and recompile)`}</li>
    </ul>
    <h3 {...{
      "id": "graphql-patterns"
    }}>{`GraphQL Patterns`}</h3>
    <h4 {...{
      "id": "mutation-responses-union-types"
    }}>{`Mutation Responses (Union Types)`}</h4>
    <p>{`Expect union responses and check `}<inlineCode parentName="p">{`__typename`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const result = await updateUser({ variables: { id, input } })

if (result.data.updateUser.__typename === 'InvalidFieldErrors') {
  // Error structure: { errors: [{ field, reason }] }
  const errorMap = mapValues(
    keyBy(result.data.updateUser.errors, 'field'),
    'reason'
  )
  setErrors(errorMap)
} else {
  // Success: result.data.updateUser is the User type
  handleSuccess(result.data.updateUser)
}
`}</code></pre>
    <h4 {...{
      "id": "data-sharing-pattern"
    }}>{`Data Sharing Pattern`}</h4>
    <p><strong parentName="p">{`For new code`}</strong>{`: Use dedicated Context API or Apollo cache for sharing data between components.`}</p>
    <p><strong parentName="p">{`Existing pattern`}</strong>{` (legacy from React Router 7 migration - avoid in new code):`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// Some existing routes use useOutletContext - when reading existing code:
const { initialUser, onChange } = useOutletContext()
`}</code></pre>
    <h4 {...{
      "id": "schema-updates"
    }}>{`Schema Updates`}</h4>
    <p>{`When backend schema changes: `}<inlineCode parentName="p">{`node scripts/generate-graphql-schema`}</inlineCode>{` (requires backend), restart editor/ESLint. ESLint uses schema to validate queries - regenerate if unknown field errors.`}</p>
    <hr></hr>
    <h2 {...{
      "id": "testing"
    }}>{`Testing`}</h2>
    <p>{`Testing standards and patterns are documented in `}<inlineCode parentName="p">{`.claude/rules/testing.md`}</inlineCode>{`. This file is automatically loaded when working with test files (`}<inlineCode parentName="p">{`*.test.*`}</inlineCode>{` or `}<inlineCode parentName="p">{`*.spec.*`}</inlineCode>{`).`}</p>
    <hr></hr>
    <h2 {...{
      "id": "task-based-recipes"
    }}>{`Task-Based Recipes`}</h2>
    <h3 {...{
      "id": "addmodify-routes"
    }}>{`Add/Modify Routes`}</h3>
    <ol>
      <li parentName="ol">{`Open `}<inlineCode parentName="li">{`app/src/routes.jsx`}</inlineCode>{` (React Router 7 `}<inlineCode parentName="li">{`createBrowserRouter`}</inlineCode>{`)`}</li>
      <li parentName="ol">{`Import the page component`}</li>
      <li parentName="ol">{`Extend the route tree:`}
        <ul parentName="li">
          <li parentName="ul">{`Use `}<inlineCode parentName="li">{`Navigate`}</inlineCode>{` helper to preserve search params`}</li>
          <li parentName="ul">{`Wrap auth-required branches with `}<inlineCode parentName="li">{`Protected`}</inlineCode></li>
          <li parentName="ul">{`Use layouts like `}<inlineCode parentName="li">{`AppLayout`}</inlineCode>{` for standard nav/header`}</li>
        </ul>
      </li>
      <li parentName="ol">{`For nested/modal routes, nest under parent route`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{
  path: '/users/:id',
  element: <Protected><AppLayout><UserPage /></AppLayout></Protected>,
  children: [
    { path: 'edit', element: <UserEditModal /> }
  ]
}
`}</code></pre>
    <h3 {...{
      "id": "addmodify-pages"
    }}>{`Add/Modify Pages`}</h3>
    <ol>
      <li parentName="ol">{`Create component under appropriate `}<inlineCode parentName="li">{`app/src/pages*`}</inlineCode>{` directory:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`pages-builder/`}</inlineCode>{` for configuration UI`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`pages-runner/`}</inlineCode>{` for end-user runtime`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`pages/`}</inlineCode>{` for system administration`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`pages-anonymous/`}</inlineCode>{` for public/unauthenticated`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Wrap in `}<inlineCode parentName="li">{`AppLayout`}</inlineCode>{` if it needs standard nav/header`}</li>
      <li parentName="ol">{`Colocate page-specific GraphQL operations near the page`}</li>
      <li parentName="ol">{`Wire route in `}<inlineCode parentName="li">{`app/src/routes.jsx`}</inlineCode></li>
      <li parentName="ol">{`Add `}<inlineCode parentName="li">{`Protected`}</inlineCode>{` wrapper if authentication required`}</li>
      <li parentName="ol">{`Add feature-flag gating if needed`}</li>
    </ol>
    <h3 {...{
      "id": "updateadd-graphql-operations"
    }}>{`Update/Add GraphQL Operations`}</h3>
    <ol>
      <li parentName="ol">{`Colocate query/mutation/fragments with the page/component`}</li>
      <li parentName="ol">{`If ESLint complains about unknown fields:`}
        <ul parentName="li">
          <li parentName="ul">{`Regenerate schema: `}<inlineCode parentName="li">{`node scripts/generate-graphql-schema`}</inlineCode>{` (requires backend running)`}</li>
          <li parentName="ul">{`Restart editor/ESLint`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Consider cache `}<inlineCode parentName="li">{`typePolicies`}</inlineCode>{` only if custom merge/key needed (in `}<inlineCode parentName="li">{`app/src/gql/index.jsx`}</inlineCode>{`)`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`pnpm test:no-coverage`}</inlineCode>{` and `}<inlineCode parentName="li">{`pnpm test:lint`}</inlineCode></li>
    </ol>
    <h3 {...{
      "id": "styling-changes"
    }}>{`Styling Changes`}</h3>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Component styles`}</strong>{`: Use Tailwind CSS utilities for all component-specific styling`}</li>
      <li parentName="ol"><strong parentName="li">{`Global styles`}</strong>{`: Edit `}<inlineCode parentName="li">{`app/src/app.css`}</inlineCode>{` only for design system primitives (buttons, inputs, typography, etc.)`}</li>
      <li parentName="ol"><strong parentName="li">{`Never edit`}</strong>{` `}<inlineCode parentName="li">{`app/src/app.dist.css`}</inlineCode>{` (generated)`}</li>
      <li parentName="ol">{`For global CSS changes:`}
        <ul parentName="li">
          <li parentName="ul">{`Run `}<inlineCode parentName="li">{`pnpm build:css`}</inlineCode>{` manually, or`}</li>
          <li parentName="ul">{`Dev watcher handles it automatically`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Verify changes with `}<inlineCode parentName="li">{`pnpm test:no-coverage`}</inlineCode></li>
    </ol>
    <h3 {...{
      "id": "feature-flags"
    }}>{`Feature Flags`}</h3>
    <h4 {...{
      "id": "check-existing-flags"
    }}>{`Check Existing Flags`}</h4>
    <ul>
      <li parentName="ul">{`Location: `}<inlineCode parentName="li">{`app/src/components/feature-flags.tsx`}</inlineCode></li>
      <li parentName="ul">{`Use exported booleans/helpers in components`}</li>
      <li parentName="ul">{`Modal available via `}<inlineCode parentName="li">{`?center-modal=feature-flags`}</inlineCode></li>
    </ul>
    <h4 {...{
      "id": "addmodify-flag"
    }}>{`Add/Modify Flag`}</h4>
    <ol>
      <li parentName="ol">{`Define in `}<inlineCode parentName="li">{`app/src/components/feature-flags.tsx`}</inlineCode>{` (id, default, description)`}</li>
      <li parentName="ol">{`Gate UI in components/pages`}</li>
      <li parentName="ol">{`In tests:`}
        <ul parentName="li">
          <li parentName="ul">{`Use `}<inlineCode parentName="li">{`setFlag`}</inlineCode>{`/`}<inlineCode parentName="li">{`clearFlag`}</inlineCode>{` from `}<inlineCode parentName="li">{`@/components/feature-flags`}</inlineCode>{` to toggle flag state`}</li>
          <li parentName="ul">{`Update `}<inlineCode parentName="li">{`.test/setup.js`}</inlineCode>{` defaults if new flag should be on by default`}</li>
        </ul>
      </li>
      <li parentName="ol">{`Cover both flag states (on/off) with tests`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`pnpm test:no-coverage`}</inlineCode>{` and `}<inlineCode parentName="li">{`pnpm test:lint`}</inlineCode></li>
    </ol>
    <h4 {...{
      "id": "removing-feature-flags"
    }}>{`Removing Feature Flags`}</h4>
    <p>{`When removing permanently enabled feature flags:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Logic Analysis`}</strong>{`: For each conditional check, determine what the condition evaluates to when the flag is TRUE`}</p>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`if (flag)`}</inlineCode>{` → condition is TRUE, keep the if-block content`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`if (!flag)`}</inlineCode>{` → condition is FALSE, remove entire if-block`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`if (flag || other)`}</inlineCode>{` → condition is FALSE, remove entire if-block`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`if (!flag && other)`}</inlineCode>{` → condition is FALSE, remove entire if-block`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`if (flag && other)`}</inlineCode>{` → simplifies to `}<inlineCode parentName="li">{`if (other)`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`if (!flag || other)`}</inlineCode>{` → simplifies to `}<inlineCode parentName="li">{`if (other)`}</inlineCode></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Variable Cleanup`}</strong>{`: After removing conditionals, look for variables that are no longer needed:`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Variables only used in removed conditions`}</li>
          <li parentName="ul">{`Variables that are simple reassignments of other variables`}</li>
          <li parentName="ul">{`Arrays with `}<inlineCode parentName="li">{`.filter(Boolean)`}</inlineCode>{` when all elements are now unconditional`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Spread Operator Arrays`}</strong>{`: When removing conditional spreads:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-javascript"
          }}>{`// Before:
const arr = [A, ...(flag ? [B] : []), C].filter(Boolean)
// After (flag=TRUE):
const arr = [A, B, C]  // Remove filter(Boolean) too
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Self-Review`}</strong>{`: Apply the Self-Review Checklist to catch simplification opportunities`}</p>
      </li>
    </ol>
    <h3 {...{
      "id": "translations-i18n"
    }}>{`Translations (i18n)`}</h3>
    <h4 {...{
      "id": "addupdate-ui-copy"
    }}>{`Add/Update UI Copy`}</h4>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Wrap user-facing text in Lingui macros:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-javascript"
          }}>{`import { useLingui } from '@lingui/react'
import { Trans } from '@lingui/react/macro'

;<Trans>New text</Trans>
const { t } = useLingui()
const msg = t\`Dynamic message\`
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Use `}<inlineCode parentName="p">{`i18n.date(date)`}</inlineCode>{` and `}<inlineCode parentName="p">{`i18n.number(num)`}</inlineCode>{` for formatting`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run `}<inlineCode parentName="p">{`pnpm extract`}</inlineCode>{` to refresh .po catalogs`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Commit the .po file changes`}</strong></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run `}<inlineCode parentName="p">{`pnpm build:i18n`}</inlineCode>{` (or let dev watcher handle it)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run `}<inlineCode parentName="p">{`pnpm test:no-coverage`}</inlineCode></p>
      </li>
    </ol>
    <h3 {...{
      "id": "writing-tests"
    }}>{`Writing Tests`}</h3>
    <ol>
      <li parentName="ol">{`Add Vitest/Testing Library specs near components or under `}<inlineCode parentName="li">{`app/src/__tests__`}</inlineCode></li>
      <li parentName="ol">{`Import helpers from `}<inlineCode parentName="li">{`@testing/*`}</inlineCode></li>
      <li parentName="ol">{`Use `}<inlineCode parentName="li">{`mountApp`}</inlineCode>{`, `}<inlineCode parentName="li">{`renderPage`}</inlineCode>{`, or `}<inlineCode parentName="li">{`renderGadgetConfig`}</inlineCode>{` as appropriate`}</li>
      <li parentName="ol">{`Create custom `}<inlineCode parentName="li">{`Mockley`}</inlineCode>{` instance if default mocks insufficient`}</li>
      <li parentName="ol">{`Load locales: `}<inlineCode parentName="li">{`await loadLocale('en')`}</inlineCode>{` before asserting translated text`}</li>
      <li parentName="ol">{`Follow Testing Library query priority (prefer `}<inlineCode parentName="li">{`getByRole`}</inlineCode>{`)`}</li>
      <li parentName="ol">{`Run `}<inlineCode parentName="li">{`pnpm test:no-coverage`}</inlineCode>{` for quick feedback`}</li>
    </ol>
    <h3 {...{
      "id": "regenerate-generated-files"
    }}>{`Regenerate Generated Files`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Icons`}</strong>{`: Use `}<inlineCode parentName="li">{`scripts/import-icons/`}</inlineCode>{` (never edit `}<inlineCode parentName="li">{`app/src/icons/index.tsx`}</inlineCode>{`)`}</li>
      <li parentName="ul"><strong parentName="li">{`GraphQL Schema`}</strong>{`: `}<inlineCode parentName="li">{`node scripts/generate-graphql-schema`}</inlineCode>{` (requires backend), restart editor after`}</li>
      <li parentName="ul"><strong parentName="li">{`CSP`}</strong>{`: `}<inlineCode parentName="li">{`scripts/generate-csp`}</inlineCode>{` (when adding external domains)`}</li>
      <li parentName="ul"><strong parentName="li">{`Browser Support`}</strong>{`: `}<inlineCode parentName="li">{`scripts/generate-browser-check`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "addmodify-gadgets"
    }}>{`Add/Modify Gadgets`}</h3>
    <p><strong parentName="p">{`Full guide`}</strong>{`: `}<inlineCode parentName="p">{`app/src/formbot/gadgets/gadgets.mdx`}</inlineCode>{` (requirements checklist, examples, three-repo structure)`}</p>
    <p>{`Gadgets live in `}<inlineCode parentName="p">{`app/src/formbot/gadgets/`}</inlineCode>{`. File structure:`}</p>
    <pre><code parentName="pre" {...{}}>{`app/src/formbot/gadgets/my-gadget/
  manifest.jsx       # Ties everything together
  edit.jsx          # Runtime edit (functional component + hooks)
  view.jsx          # Display component
  config.jsx        # Configuration UI
  validation.jsx    # validateShape (custom validator)
  utils.js          # Business logic (formatting, parsing) - pure functions
  icon.svg.jsx      # SVG icon
  progressive-disclosure.jsx  # (optional) Conditional visibility
  filters.jsx       # (optional) Document list filtering
`}</code></pre>
    <p><strong parentName="p">{`Modern patterns (functional components, Tailwind, utils separation):`}</strong></p>
    <ul>
      <li parentName="ul">{`Use `}<inlineCode parentName="li">{`useState`}</inlineCode>{`/`}<inlineCode parentName="li">{`useRef`}</inlineCode>{`/`}<inlineCode parentName="li">{`useEffect`}</inlineCode>{`, not class components`}</li>
      <li parentName="ul">{`Use Tailwind CSS for styling`}</li>
      <li parentName="ul">{`Abstract business logic into `}<inlineCode parentName="li">{`utils.js`}</inlineCode>{` (pure functions) - see Currency, PhoneNumber, Table gadgets`}</li>
      <li parentName="ul">{`Include ARIA attributes: `}<inlineCode parentName="li">{`aria-labelledby`}</inlineCode>{`, `}<inlineCode parentName="li">{`aria-describedby`}</inlineCode>{`, `}<inlineCode parentName="li">{`aria-required`}</inlineCode>{`, `}<inlineCode parentName="li">{`aria-invalid`}</inlineCode></li>
      <li parentName="ul">{`Reference examples: Text (basic structure), PhoneNumber (modern best practices)`}</li>
    </ul>
    <p><strong parentName="p">{`Third-party libraries:`}</strong>{` Only MIT/BSD/Apache 2.0 licenses - `}<strong parentName="p">{`no GPL/AGPL/copyleft`}</strong>{`. Check `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` license field before adding dependencies.`}</p>
    <p><strong parentName="p">{`Testing:`}</strong>{` Aim for 15-20+ tests (component, utils, edge cases, accessibility). Use `}<inlineCode parentName="p">{`renderGadgetConfig`}</inlineCode>{`/`}<inlineCode parentName="p">{`renderGadgetEdit`}</inlineCode>{` from `}<inlineCode parentName="p">{`@testing/setup`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Register in `}<inlineCode parentName="strong">{`app/src/formbot/index.jsx`}</inlineCode>{`:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import MyGadget from './gadgets/my-gadget/manifest'

formbot.registerGadget('MyGadget', MyGadget)
`}</code></pre>
    <p><strong parentName="p">{`Multi-repo:`}</strong>{` UI in `}<inlineCode parentName="p">{`builder-ui/app/src/formbot/gadgets`}</inlineCode>{`, server validation in `}<inlineCode parentName="p">{`platform/lib/formbot/gadgets`}</inlineCode>{` (Elixir), form processing in `}<inlineCode parentName="p">{`forms-api/server/lib/gadgets`}</inlineCode>{` (Node.js)`}</p>
    <p><strong parentName="p">{`Field reference detection:`}</strong>{` If your gadget/feature stores references to `}<inlineCode parentName="p">{`meta.createdBy`}</inlineCode>{` or `}<inlineCode parentName="p">{`meta.submittedBy`}</inlineCode>{` fields (including extended attributes), update `}<inlineCode parentName="p">{`app/src/pages-builder/form/extended-attribute-usage-utils.ts`}</inlineCode>{` to detect those references. This prevents admins from removing fields that are in use. See existing patterns in that file.`}</p>
    <hr></hr>
    <h2 {...{
      "id": "debugging-playbook"
    }}>{`Debugging Playbook`}</h2>
    <h3 {...{
      "id": "graphql"
    }}>{`GraphQL`}</h3>
    <p>{`Check DevTools Network → inspect `}<inlineCode parentName="p">{`__typename`}</inlineCode>{` for union types. Verify query includes required fields. Regenerate schema if lint errors (`}<inlineCode parentName="p">{`node scripts/generate-graphql-schema`}</inlineCode>{`). Check Apollo cache. Common: missing `}<inlineCode parentName="p">{`__typename`}</inlineCode>{` checks, stale schema, cache merge issues (see type policies section).`}</p>
    <h3 {...{
      "id": "sso-vs-password"
    }}>{`SSO vs Password`}</h3>
    <p>{`Check `}<inlineCode parentName="p">{`user.ssoId`}</inlineCode>{`: present = SSO-only, absent = password auth. Hide password fields when `}<inlineCode parentName="p">{`user.ssoId`}</inlineCode>{` exists. Backend returns HTTP 400 if SSO user attempts password change.`}</p>
    <h3 {...{
      "id": "form-state-modals-validation"
    }}>{`Form State, Modals, Validation`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Form state`}</strong>{`: Fields disappearing → spread entire object in onChange (see State Management)`}</li>
      <li parentName="ul"><strong parentName="li">{`Modals`}</strong>{`: Missing `}<inlineCode parentName="li">{`id="modal-title"`}</inlineCode>{` on heading or focus not returned to trigger (see Modal Usage)`}</li>
      <li parentName="ul"><strong parentName="li">{`Validation`}</strong>{`: Use `}<inlineCode parentName="li">{`touched`}</inlineCode>{` flags; error containers need `}<inlineCode parentName="li">{`role="alert"`}</inlineCode>{`; reference via `}<inlineCode parentName="li">{`aria-describedby`}</inlineCode>{`; set `}<inlineCode parentName="li">{`aria-invalid="true"`}</inlineCode>{` on inputs with errors`}</li>
    </ul>
    <h3 {...{
      "id": "test-failures"
    }}>{`Test Failures`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Translations`}</strong>{`: Run `}<inlineCode parentName="li">{`pnpm build:i18n`}</inlineCode>{`, add `}<inlineCode parentName="li">{`await loadLocale('en')`}</inlineCode>{` before assertions`}</li>
      <li parentName="ul"><strong parentName="li">{`GraphQL data`}</strong>{`: Check `}<inlineCode parentName="li">{`app/src/@testing/mocks/`}</inlineCode>{`, use `}<inlineCode parentName="li">{`api.debug()`}</inlineCode>{` to dump mock data`}</li>
      <li parentName="ul"><strong parentName="li">{`Timezone`}</strong>{`: All tests run under `}<inlineCode parentName="li">{`TZ=Etc/UTC`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Coverage`}</strong>{`: Use `}<inlineCode parentName="li">{`pnpm test:no-coverage`}</inlineCode>{` for targeted runs (full suite enforces thresholds)`}</li>
      <li parentName="ul"><strong parentName="li">{`Element not found`}</strong>{`: Use `}<inlineCode parentName="li">{`find*`}</inlineCode>{` queries (async), follow Testing Library query priority`}</li>
      <li parentName="ul"><strong parentName="li">{`Act warnings`}</strong>{`: Async state not awaited - wrap in `}<inlineCode parentName="li">{`waitFor`}</inlineCode>{` or use `}<inlineCode parentName="li">{`find*`}</inlineCode>{` queries`}</li>
    </ul>
    <h3 {...{
      "id": "dev-server-issues"
    }}>{`Dev Server Issues`}</h3>
    <p>{`Verify PORT (default 52002), check backend running, try `}<inlineCode parentName="p">{`pnpm dev:docked`}</inlineCode>{`, check port conflicts (`}<inlineCode parentName="p">{`lsof -i :52002`}</inlineCode>{`), clear cache (`}<inlineCode parentName="p">{`rm -rf node_modules/.vite`}</inlineCode>{`).`}</p>
    <h3 {...{
      "id": "build-issues"
    }}>{`Build Issues`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`CSS`}</strong>{`: Edit `}<inlineCode parentName="li">{`app.css`}</inlineCode>{` not `}<inlineCode parentName="li">{`app.dist.css`}</inlineCode>{`, run `}<inlineCode parentName="li">{`pnpm build:css`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`Translations`}</strong>{`: `}<inlineCode parentName="li">{`pnpm extract`}</inlineCode>{` → `}<inlineCode parentName="li">{`pnpm build:i18n`}</inlineCode></li>
      <li parentName="ul"><strong parentName="li">{`GraphQL lint`}</strong>{`: Regenerate schema`}</li>
      <li parentName="ul"><strong parentName="li">{`Build fails`}</strong>{`: Run `}<inlineCode parentName="li">{`pnpm build`}</inlineCode>{` (CSS → i18n → JS)`}</li>
    </ul>
    <hr></hr>
    <h2 {...{
      "id": "code-quality--workflows"
    }}>{`Code Quality & Workflows`}</h2>
    <h3 {...{
      "id": "linting--formatting"
    }}>{`Linting & Formatting`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`ESLint`}</strong>{`: `}<inlineCode parentName="li">{`pnpm test:lint`}</inlineCode>
        <ul parentName="li">
          <li parentName="ul">{`Includes GraphQL lint (uses schema to validate queries)`}</li>
          <li parentName="ul">{`Enforces kebab-case filenames`}</li>
          <li parentName="ul">{`StandardJS code style`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`Prettier`}</strong>{`: `}<inlineCode parentName="li">{`pnpm test:prettier`}</inlineCode>
        <ul parentName="li">
          <li parentName="ul">{`Custom import ordering`}</li>
          <li parentName="ul">{`No semicolons, 2-space indent`}</li>
        </ul>
      </li>
      <li parentName="ul"><strong parentName="li">{`Format`}</strong>{`: `}<inlineCode parentName="li">{`pnpm format`}</inlineCode>{` (applies Prettier)`}</li>
      <li parentName="ul"><strong parentName="li">{`License check`}</strong>{`: `}<inlineCode parentName="li">{`pnpm test:license`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "git--pull-requests"
    }}>{`Git & Pull Requests`}</h3>
    <ul>
      <li parentName="ul">{`Main branch: `}<inlineCode parentName="li">{`master`}</inlineCode></li>
      <li parentName="ul">{`Husky runs pre-commit hooks (Prettier + ESLint)`}</li>
      <li parentName="ul">{`StandardJS: No semicolons, 2-space indent`}</li>
      <li parentName="ul">{`Common commands referenced throughout doc; run `}<inlineCode parentName="li">{`pnpm run`}</inlineCode>{` to see all available scripts`}</li>
    </ul>
    <h4 {...{
      "id": "pr-labels-required"
    }}>{`PR Labels (Required)`}</h4>
    <p>{`Every PR must have a "Change type" label:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li"><inlineCode parentName="strong">{`change_type/application`}</inlineCode></strong>{` - Use for most PRs (code changes, features, bug fixes, tests)`}</li>
      <li parentName="ul"><strong parentName="li"><inlineCode parentName="strong">{`change_type/infrastructure`}</inlineCode></strong>{` - Use only for configuration file changes (CI/CD, build config, etc.)`}</li>
    </ul>
    <p>{`Add labels when creating PRs:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`gh pr create --title "Title" --body "Description" --label "change_type/application"
`}</code></pre>
    <h3 {...{
      "id": "pre-submission-verification"
    }}>{`Pre-Submission Verification`}</h3>
    <p>{`Always run: `}<inlineCode parentName="p">{`pnpm test:no-coverage`}</inlineCode>{`, `}<inlineCode parentName="p">{`pnpm test:lint`}</inlineCode>{`, `}<inlineCode parentName="p">{`pnpm test:prettier`}</inlineCode></p>
    <p><strong parentName="p">{`Check ESLint on changed files as you work`}</strong>{`: After modifying or creating files, run `}<inlineCode parentName="p">{`pnpm eslint "path/to/changed/file.jsx"`}</inlineCode>{` before moving on.`}</p>
    <p>{`Task-specific requirements covered in Task Recipes sections above (GraphQL schema regen, i18n extract, CSS build, etc.)`}</p>
    <h3 {...{
      "id": "common-pitfalls"
    }}>{`Common Pitfalls`}</h3>
    <p>{`Don't: edit generated files, call `}<inlineCode parentName="p">{`t()`}</inlineCode>{` at module root, create unnecessary files, add unrequested features, partially update state, test implementation details, assume methods exist`}</p>
    <hr></hr>
    <p><strong parentName="p">{`Last Updated`}</strong>{`: 2025-11-28
`}<strong parentName="p">{`Maintained By`}</strong>{`: AI Agents (update as project evolves)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      